<template>
  <div class="startup-container">
    <div
      v-if="screenConfig"
      class="screen-config-container"
    >
      <Settings v-if="(!isBookieIdSet || !isScreenNameSet) && screenConfig.mode === 'startup'" />
      <Venue v-if="screenConfig.mode === 'venue'" />
      <VenueSmall v-if="screenConfig.mode === 'venuesmall'" />
      <NextThree v-if="screenConfig.mode === 'nextthree'" />
      <Results v-if="screenConfig.mode === 'results'" />
      <Brand v-if="screenConfig.mode === 'brand'" />
      <Four v-if="screenConfig.mode === 'four'" />
      <div
        v-if="$store.state.isLoading && !$store.state.refreshingPrice"
        class="screen-loading"
      >
        <div class="container">
          <div class="loader">
            <div class="loader--dot" />
            <div class="loader--dot" />
            <div class="loader--dot" />
            <div class="loader--dot" />
            <div class="loader--dot" />
            <div class="loader--dot" />
            <div class="loader--text">
              {{ $store.state.screenLoadingMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Settings from '@/components/Settings';
import Venue from '@/components/Venue';
import VenueSmall from '@/components/VenueSmall';
import NextThree from '@/components/NextThree';
import Results from '@/components/Results';
import Brand from '@/components/Brand';
import Four from '@/components/Four';
import Vue from 'vue';
import axios from 'axios';
import VueSocketio from 'vue-socket.io';
import { store } from '../store';
import venuemixin from '../mixins/venuemixin';
import moment from 'moment';

Vue.use(VueSocketio, store.state.socketServerUrl);

export default {
  name: 'Startup',
  components: {
    Settings,
    Venue,
    VenueSmall,
    NextThree,
    Results,
    Brand,
    Four
  },
  mixins: [venuemixin],
  data() {
    return {
      socketConnected: false,
      showRetry: false
    };
  },
  computed: {
    isBookieIdSet() {
      return this.$store.getters.isBookieIdSet;
    },
    screenConfig() {
      return this.$store.getters.screenConfig;
    },
    isScreenRefresh(){
      return this.$store.getters.isScreenRefresh;
    },
    isScreenNameSet() {
      return sessionStorage.getItem('screenName') !== null;
    }
  },
  created() {
    setTimeout(() => {
      if (!this.socketConnected) {
        this.$store.commit('changeInfoBarMessage', 'Unable to connect to Socket Server');
        this.$store.commit('changeInfoBarClassName', 'infobar infobar-error');
        this.showRetry = true;
      }
    }, 4000);
  },
  methods: {
    retry() {
      localStorage.removeItem('bookieId');
      sessionStorage.removeItem('screenName');
      this.$store.commit('resetScreen');
      window.location.href = '/#/';
      window.location.reload();
    }
  },
  method: {
    resetScreen(){
      localStorage.removeItem('bookieId');
      sessionStorage.removeItem('screenName');

      this.$store.commit('resetScreen');

      window.location.href = '/';
    }
  },
  sockets: {
    connect() {
      this.socketConnected = true;
      this.showRetry = false;
      this.$store.commit('changeInfoBarMessage', 'Socket Connected');
      this.$store.commit('changeInfoBarClassName', 'infobar');

      // Set delay to ensure bookieid has been loaded correctly first
      setTimeout(() => {
        this.$store.commit('changeInfoBarClassName', 'infobar');

        if (this.$store.state.bookieId !== null && this.isScreenNameSet) {
          this.$socket.emit('messageFromClient', {
            messageType: 'link',
            data: {
              bookieId: this.$store.state.bookieId,
              socketId: this.$socket.id,
              identity: this.$store.state.screenName,
              connectionType: 'screen'
            }
          });

          this.$store.commit('setSocketId', this.$socket.id);

          axios.get(`${this.$store.state.betManagerApiUrl}/bookie/${this.$store.state.bookieId}/?populate=`, {
            headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
          })
            .then((response) => {
              this.$store.commit('setBookieName', response.data.companyName);

              this.$store.commit('changeInfoBarMessage', 'Screen is connected to server using socket id: ' + this.$socket.id + ' and bookie id: ' + this.$store.state.bookieId);

              // lets now preload all fraction table data
              const fractionurl = `${this.$store.state.betManagerApiUrl}/fractiontable/?populate=`;

              axios.get(fractionurl, {
                headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
              })
                .then((response) => {
                  const fractiontable = response.data;

                  this.$store.commit('updateFractionTable', fractiontable);
                })
                .catch(error => {
                  console.log(error);
                });

              // now that we are all setup, lets check if there is a preset config for this connection
              const url = `${this.$store.state.betManagerApiUrl}/screen/?populate=&where={"bookie": "${this.$store.state.bookieId}","screenName":"${this.$store.state.screenName}"}`;

              axios.get(url, {
                headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
              }).then((response) => {
                if (!response.data.length) {
                  this.$store.commit('changeInfoBarMessage', 'It looks like this Screen Configuration does not exist. Please reset.');
                }

                this.$store.commit('changeScreenConfig', response.data[0]);

                document.body.style.fontFamily = this.$store.getters.globalFont.fontFamily;

                this.refresh();
              });
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 404) {
                  this.$store.commit('changeInfoBarMessage', 'No Bookie found with and ID of : ' + this.$store.state.bookieId);
                  this.$store.commit('changeInfoBarClassName', 'infobar infobar-error');
                }
              } else {
                this.$store.commit('changeInfoBarMessage', 'Network Error connecting to API');
                this.$store.commit('changeInfoBarClassName', 'infobar infobar-error');
              }
            });

        } else {
          if (!this.$store.state.bookieId) {
            this.$store.commit('changeInfoBarMessage', 'Connected to server but no Bookie ID present');
          }
          if(!this.isScreenNameSet) {
            this.$store.commit('changeInfoBarMessage', 'Connected to server but no Screen Name set');
          }

          this.$store.commit('updateIsLoading', false);
          this.$store.commit('updateScreenLoadingMessage', '');
        }

      }, 2000);
    },
    messageToBookie(msg) {
      switch (msg.messageType) {
        case 'config-change': {
          window.location.href = '/#/';
          window.location.reload();

          break;
        }
        case 'price-change': {
          this.$store.commit('updateRefreshingPrice', true);

          // If there was a price change and we are a venue, then refresh the whole screen
          if (this.$store.state.screenConfig.mode === 'venue' && msg.data.venueId === this.$store.state.screenData[0].venueId){
            this.$store.commit('changeInfoBarMessage', 'Last price update received at ' + moment.utc().format('HH:mm:ss'));
            this.refresh();
          }

          // If there was a price change and we are next three or four, then *placeholder text*
          if (this.$store.state.screenConfig.mode === 'nextthree' || this.$store.state.screenConfig.mode === 'four') {
            let hasRaceInNextThree = false;

            this.$store.state.screenData.forEach(bookieVenue => {
              bookieVenue.races.forEach(bookieRace => {

                if (bookieRace.raceId === msg.data.raceId) {
                  hasRaceInNextThree = true;
                }
              });
            });

            if (hasRaceInNextThree) {
              this.$store.commit('changeInfoBarMessage', 'Last price update received at ' + moment.utc().format('HH:mm:ss'));
              this.refresh();
            }
          }
        }
      }
    }
  }
};
</script>

<style>
.screen-loading {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// Startup.vue?6aaf03b5